@if (condition) {
  <div class="card">
    <h4 class="card-header">Loading...</h4>
    <div class="card-body text-xs-center">
      <i class="fa fa-circle-o-notch fa-spin fa-3x"></i>
    </div>
  </div>
}